<script setup lang="ts">
import { CONTACT_URL } from '@shared/app/constants/contactUrl';
import type { FooterNavigation } from '~~/types/footer';

const nav: FooterNavigation = {
  text: '企業情報',
  items: [
    {
      text: '運営会社',
      to: 'https://fitsplus.co.jp/',
      newWindow: true,
    },
    {
      text: '個人情報保護方針',
      to: 'https://fitsplus.co.jp/privacy',
      newWindow: true,
    },
    {
      text: 'お問い合わせ',
      to: CONTACT_URL,
      newWindow: true,
    },
  ],
};
</script>

<template>
  <footer>
    <div class="md:bg-white md:border-t md:border-b-2 md:border-gray-300">
      <div class="max-w-healthy-recipe-content-width mx-auto py-4 md:py-7">
        <div class="flex items-center max-md:justify-center">
          <p class="hidden md:flex mr-5 shrink-0 text-gray-500 font-bold">
            {{ nav.text }}
          </p>
          <div
            class="flex flex-wrap gap-4 max-md:gap-x-4 max-md:gap-y-1 max-md:justify-center"
          >
            <NuxtLink
              v-for="subItem in nav.items"
              :key="subItem.text"
              :to="subItem.to"
              :external="subItem.external"
              class="text-gray-500 hover:underline"
              :target="subItem.newWindow ? '_blank' : undefined"
              :rel="subItem.newWindow ? 'noopener' : undefined"
              >{{ subItem.text }}</NuxtLink
            >
          </div>
        </div>
      </div>
    </div>

    <div class="p-4">
      <div
        class="mx-auto max-w-healthy-recipe-content-width flex justify-between max-md:flex-col-reverse max-md:items-center max-md:gap-6 max-md:py-4"
      >
        <small class="block text-base md:text-lg text-gray-500"
          >&copy; FitsPlus Inc.</small
        >
        <img
          src="~/assets/img/privacy.gif"
          class="w-[100px]"
          alt="プライバシーマーク"
        />
      </div>
    </div>
  </footer>
</template>
